import React, { useState } from "react";
import Sidebar from "../shared/sidebar";
import Header from "../shared/header";
import Alert from "../ui/Alert/index";
// import { useTheme } from "../ui/Theme-context";

const Layout = ({ children }) => {
  // const { theme } = useTheme();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      {/* <div className={`${theme === "dark" ? "dark" : ""}`}> */}
        <div className="flex flex-col h-screen overflow-hidden ">
        <Header isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen} />
        <div className="flex-1 flex h-auto bg-[#f5f5f5] !overflow-y-auto">
          <Sidebar isMobileMenuOpen={isMobileMenuOpen}
            setIsMobileMenuOpen={setIsMobileMenuOpen} />
            <main className="flex-1 h-auto mt-16 lg:ml-14 bg-[#f5f5f5] ">
            <div className="w-full h-full p-2">{children}</div>
            </main>
          </div>
          <Alert />
        </div>
      {/* </div> */}

    </>
  );
};

export default Layout;
